import React from "react";
import { Link } from "react-router-dom";

import { Album } from "../../models";

export interface AlbumPackProps {
    album: Album;
    size?: "small" | "tiny";
    link?: boolean | string;
}

export const AlbumPack = ({ album, size, link }: AlbumPackProps) => {
    let img: JSX.Element[] = [];
    if (album != null) {
        const url = size === "tiny"
            ? album.getThumbSmallUrl()
            : album.getThumbMediumUrl();
        const linkUrl = typeof link === "string" ? link : album.getViewUrl();
        if (album.artwork != null && url != null) {
            img = [<img key="image" alt={album.artwork.alt} src={url} />];
        }

        if (typeof link === "string" || (album.id != null && (link == null || link))) {
            img = [<Link key="image" to={linkUrl}>{img}</Link>];
        }
    }
    let className = "album-pack";
    if (size === "small") {
        className += " album-pack--small";
    }
    else if (size === "tiny") {
        className += " album-pack--tiny";
    }
    return (
        <div className={className}>
            <div className="album-pack__content">
                {img}
            </div>
        </div>
    );
};
